{
  "ConferenceParticipation": "Messedeltaking",
  "EducationalOperations": "Utdanningstilbod",
  "FeasibilityStudy": "Forstude",
  "InnovationCooperation": "Innovasjonssamarbeid",
  "InnovationCounseling": "Innovasjonsrådgjeving",
  "InternationalMarketPositionsDevelopment": "Utvikling av nye eller forsterka internasjonale marknadsposisjonar",
  "InternationalMarketsKnowledge": "Oppøæring knytta til internasjonalisering",
  "Investments": "Investeringar",
  "OperationApplication": "Driftssøknad",
  "Training": "Opplæring"
}
